const domain = "accenture.com";
export const FaqData = [
  {
    id: 1,
    Question: "What is the benefit of this program?",
    Answer:
      "Enbridge Talent Academy gives an opportunity to learn and develop proficiency in technologies that are high in demand, honing Delivery & Team Management skills and be ready to deliver in the NEW.",
  },
  {
    id: 2,
    Question:
      "What is the impact of Enbridge Talent Academy on candidates' performance/ appraisals?",
    Answer: "There is no impact on the performance/appraisal",
  },
  {
    id: 3,
    Question:
      "How many hours of commitment per day is required considering a person makes time all the days of this learning program?",
    Answer:
      "The estimated hours required per week for learning is 6-8 hours which comes to nearly 1 – 1.5 hrs. of learning every day.",
  },
  {
    id: 4,
    Question:
      "After the certification, will the secondary or primary skill get updated in my competency?",
    Answer:
      "The skill will not automatically update on myCompetency. However, candidates can manually update their skill and give the proficiency assessment.",
  },
  {
    id: 5,
    Question:
      "Learning topics will be provided, or do candidates have to take their learning path?",
    Answer:
      "Candidates will get a detailed learning journey along with learning topics.",
  },
  {
    id: 6,
    Question:
      "Any study material provided by Enbridge Talent Academy will be online or offline?",
    Answer: "The learning is online.",
  },
  {
    id: 7,
    Question: " Is this a self-paced course?",
    Answer: "Yes",
  },
  {
    id: 8,
    Question:
      "Do we have any material repositories that we can refer to for detailed information?",
    Answer:
      "Learning Program will be provided as part of learning from Learning Board and Deep knowledge portal and Pluralsight.",
  },
  {
    id: 9,
    Question: "How is this learning designed?",
    Answer:
      "The learning for Enbridge Talent Academy is designed to Enbridge users while honing Delivery & Team Management skills and be ready to deliver in the NEW",
  },
  {
    id: 10,
    Question: "How to access the learning?",
    Answer:
      "The Learning Program can be accessed through Deep knowledge learning portal, Plural Sight and Learning Board.",
  },
  {
    id: 11,
    Question: "When will the candidates get the learning links?",
    Answer:
      "Deep knowledge Portal Learning Links have been communicated to candidates via email from Enbridge Talent Academy team.",
  },
  {
    id: 12,
    Question: "When can the candidates start learning?",
    Answer:
      "Candidates can start their learning journey post the kick-off call",
  },
  {
    id: 13,
    Question:
      "Do candidates have any assessment to take up at the end of the program?",
    Answer:
      "Yes. At the end of the program, the candidates should complete the final track assessment.",
  },
  {
    id: 14,
    Question:
      "Can candidates take the final assessment early if they complete the course before 4 months?",
    Answer: "Yes, they can take the final assessment early.",
  },
  {
    id: 15,
    Question:
      "Is certification voucher also be issued at the end of the course?",
    Answer: "Candidates will not get vouchers under Enbridge Talent Academy.",
  },
  {
    id: 16,
    Question:
      "After completion of the course, will candidates get any certificate?",
    Answer:
      "Candidates will get a completion certificate post-course completion.",
  },
  {
    id: 17,
    Question: "Will SME sessions be recorded?",
    Answer: "Yes, SME sessions will be recorded and shared with candidates.",
  },
  {
    id: 18,
    Question: "Will candidates get any WBS for the self-paced training?",
    Answer: "No, candidates will not be given WBSe",
  },
  {
    id: 19,
    Question: "Who will be point of contact to discuss any issue?",
    Answer: `<li>For Enbridge Talent Academy Program related queries, reach out to  <a href={mailto:LKM.Enbridge Talent Academy@${domain}}>LKM.Enbridge Talent Academy@${domain} </a></li>`,
  },
];
